
import styles from './ISDEIEHCDataExtractorCongrats.module.scss'
import { useAppDispatch, useAppSelector, useTranslation } from 'hooks';
import { BUTTON_LOOK, Button, ContactUs, ParaplannerAI, StepperTitle } from 'components_old';
import { IStepperComponentProps } from '../../types';
import { selectIntercomChatState } from 'store/chat';


export const ISDEIEHCDataExtractorCongrats = ({ handleGoToNextStep, nextStep }: IStepperComponentProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const intercomChatState = useAppSelector(selectIntercomChatState);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (!intercomChatState?.isOpen) {
  //       dispatch(setIntercomChatVisibility(true))
  //     }
  //   }, 2000);
  // }, [])


  return (
    <div className={styles.Wrapper}>
      <>
        <StepperTitle>
          <ParaplannerAI />
        </StepperTitle>

        <StepperTitle>
          <div>{t('common.congrats')}</div>
          <div>{t('automations.tiles.investmentStatementExtractionIntoExcelHumanCheck.congrats.titleA')}</div>
        </StepperTitle>

        <StepperTitle className={styles.ContactUs}>
          <div>{t('common.somethingUrgent')}</div>
          <ContactUs
            email={t('automations.tiles.investmentStatementExtractionIntoExcelHumanCheck.contact.email')}
            subject={t('automations.tiles.investmentStatementExtractionIntoExcelHumanCheck.contact.subject')}
            body={t('automations.tiles.investmentStatementExtractionIntoExcelHumanCheck.contact.body')}
          /> {t('common.forSupport')}
        </StepperTitle>
      </>

      <div className={styles.Buttons}>
        <Button
          look={BUTTON_LOOK.TERNARY}
          onClick={async () => {
            // mixpanel.track(EVENT.ANOTHER_REQUEST);
            handleGoToNextStep({ action: nextStep });
          }}
        >
          {t('dataExtractor.congrats.newRequest')}
        </Button>
      </div>
    </div >
  );
}
